import { render, staticRenderFns } from "./ClaimItemHelpList.vue?vue&type=template&id=4aa54cd3&"
import script from "./ClaimItemHelpList.vue?vue&type=script&lang=js&"
export * from "./ClaimItemHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports